function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGirl3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#365e7d"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 110.055,
    cy: 67.672,
    r: 67.665,
    fill: "#365e7d",
    "data-original": "#365e7d",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.945,
    cy: 67.672,
    r: 67.665,
    fill: "#365e7d",
    "data-original": "#365e7d",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#2b4d66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m136.571 129.945c-8.138 3.472-17.101 5.388-26.516 5.388-37.364 0-67.661-30.297-67.661-67.661-.001-37.375 30.296-67.672 67.661-67.672 9.416 0 18.378 1.916 26.516 5.388-24.188 10.322-41.145 34.325-41.145 62.284 0 27.958 16.957 51.951 41.145 62.273z",
    fill: "#2b4d66",
    "data-original": "#2b4d66",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m428.469 129.945c-8.138 3.472-17.101 5.388-26.516 5.388-37.374 0-67.672-30.297-67.672-67.661 0-37.375 30.297-67.672 67.671-67.672 9.416 0 18.378 1.916 26.516 5.388-24.199 10.322-41.155 34.325-41.155 62.284.001 27.958 16.957 51.951 41.156 62.273z",
    fill: "#2b4d66",
    "data-original": "#2b4d66",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m386.525 512h-261.045c21.191-35.821 56.699-62.166 98.652-71.143v-55.233h63.74v55.233c41.953 8.977 77.461 35.322 98.653 71.143z",
    fill: "#c7348d",
    "data-original": "#b3e59f",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241.745 385.619v55.238c-18.78 8.973-34.665 35.324-44.153 71.143h-72.112c21.191-35.819 56.7-62.171 98.649-71.143v-55.238z",
    fill: "#a53579",
    "data-original": "#95d6a4",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288.732 419.951h-66.651c-7.283 0-13.187-5.904-13.187-13.187v-7.954c0-7.283 5.904-13.187 13.187-13.187h66.651c7.283 0 13.187 5.904 13.187 13.187v7.954c0 7.283-5.904 13.187-13.187 13.187z",
    fill: "#c7348d",
    "data-original": "#b3e59f",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261.134 419.955h-39.054c-7.283 0-13.186-5.903-13.186-13.186v-7.953c0-7.283 5.903-13.196 13.186-13.196h39.054c-7.283 0-13.186 5.913-13.186 13.196v7.953c0 7.283 5.903 13.186 13.186 13.186z",
    fill: "#a53579",
    "data-original": "#95d6a4",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    d: "m256 46.268c-81.394 0-147.377 65.983-147.377 147.377v78.863h294.754v-78.863c0-81.395-65.983-147.377-147.377-147.377z",
    fill: "#365e7d",
    "data-original": "#365e7d",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305.602 54.828c-56.989 20.366-97.773 74.821-97.773 138.815v78.859h-99.205v-78.859c0-81.393 65.982-147.376 147.376-147.376 17.399.001 34.098 3.019 49.602 8.561z",
    fill: "#2b4d66",
    "data-original": "#2b4d66",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ffcbbe"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 114.332,
    cy: 272.884,
    r: 40.809,
    fill: "#b48764",
    "data-original": "#ffcbbe",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 397.675,
    cy: 272.884,
    r: 40.809,
    fill: "#b48764",
    "data-original": "#ffcbbe",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#eaac9d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m139.925 283.876c-2.714 0-5.347-1.432-6.76-3.972-2.425-4.361-6.594-6.781-12.743-7.399-5.029-.505-9.388.486-9.43.496-4.148 1.016-8.328-1.518-9.345-5.662s1.518-8.328 5.662-9.345c.692-.17 6.976-1.636 14.657-.865 11.235 1.129 19.778 6.407 24.704 15.264 2.074 3.729.732 8.434-2.997 10.508-1.189.661-2.477.975-3.748.975z",
    fill: "#966d50",
    "data-original": "#eaac9d",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m372.081 283.876c-1.271 0-2.559-.314-3.748-.975-3.729-2.074-5.07-6.779-2.997-10.508 4.927-8.857 13.469-14.135 24.704-15.264 7.682-.77 13.967.695 14.657.865 4.145 1.017 6.68 5.201 5.663 9.345-1.015 4.134-5.178 6.663-9.314 5.67-.143-.033-4.66-1.055-9.83-.465-5.952.681-10 3.089-12.375 7.36-1.412 2.54-4.045 3.972-6.76 3.972z",
    fill: "#966d50",
    "data-original": "#eaac9d",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    d: "m377.235 235.915v40.238c0 61.697-50.015 111.711-111.711 111.711h-19.037c-61.697 0-111.722-50.015-111.722-111.711v-40.238l11.641-25.662c4.584-10.106 11.909-18.409 20.871-24.188s19.553-9.024 30.658-9.024c24.868 0 46.831-16.246 54.104-40.032l3.966-12.98 3.966 12.98c3.637 11.898 10.94 21.901 20.449 28.937 9.508 7.036 21.211 11.095 33.656 11.095 22.21 0 42.36 12.99 51.529 33.212z",
    fill: "#c39772",
    "data-original": "#ffddce",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m289.496 385.279c-7.716 1.7-15.741 2.586-23.972 2.586h-19.037c-61.697 0-111.722-50.015-111.722-111.711v-40.238l11.641-25.662c4.584-10.106 11.909-18.409 20.871-24.188s19.553-9.024 30.658-9.024c1.277 0 2.544-.041 3.812-.124v99.236c-.001 53.465 37.569 98.164 87.749 109.125z",
    fill: "#b48764",
    "data-original": "#ffcbbe",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#2b4d66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m198.422 237.069c-2.924 0-5.626 1.292-7.84 3.462l-5.109-3.634c-3.477-2.474-8.301-1.66-10.775 1.817s-1.66 8.301 1.817 10.775l8.393 5.971c0 .044-.005.087-.005.131 0 10.213 6.064 18.522 13.519 18.522s13.519-8.309 13.519-18.522-6.065-18.522-13.519-18.522z",
    fill: "#2b4d66",
    "data-original": "#2b4d66",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m337.309 238.713c-2.474-3.478-7.298-4.291-10.775-1.817l-5.109 3.634c-2.214-2.17-4.916-3.462-7.84-3.462-7.454 0-13.519 8.308-13.519 18.521s6.064 18.522 13.519 18.522c7.454 0 13.519-8.309 13.519-18.522 0-.044-.005-.087-.005-.131l8.393-5.971c3.477-2.472 4.291-7.296 1.817-10.774z",
    fill: "#2b4d66",
    "data-original": "#2b4d66",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    d: "m215.801 218.338c-1.977 0-3.955-.754-5.463-2.263-2.97-2.97-6.918-4.605-11.117-4.605-4.2 0-8.147 1.635-11.117 4.605-3.017 3.017-7.909 3.018-10.927 0-3.017-3.017-3.018-7.909 0-10.927 5.888-5.888 13.716-9.131 22.044-9.131s16.156 3.243 22.044 9.131c3.018 3.018 3.017 7.909 0 10.927-1.509 1.508-3.487 2.263-5.464 2.263z",
    fill: "#365e7d",
    "data-original": "#365e7d",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330.532 218.338c-1.977 0-3.955-.755-5.463-2.263-2.97-2.969-6.918-4.605-11.117-4.605-4.2 0-8.148 1.636-11.118 4.605-3.017 3.017-7.909 3.017-10.927 0s-3.018-7.909 0-10.927c12.155-12.154 31.933-12.155 44.088 0 3.018 3.017 3.018 7.909 0 10.927-1.509 1.508-3.486 2.263-5.463 2.263z",
    fill: "#365e7d",
    "data-original": "#365e7d",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 314.976c-14.268 0-27.077-9.541-31.15-23.202-1.219-4.09 1.108-8.393 5.197-9.612s8.392 1.108 9.612 5.197c2.135 7.162 8.855 12.165 16.342 12.165 7.495 0 14.214-4.999 16.339-12.156 1.215-4.091 5.513-6.422 9.606-5.208 4.091 1.215 6.422 5.516 5.208 9.606-4.059 13.665-16.87 23.21-31.154 23.21z",
    fill: "#966d50",
    "data-original": "#eaa598",
    style: {},
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirl3);
export default __webpack_public_path__ + "static/media/girl3.d9b6f0981804b62d25b317991cff968a.svg";
export { ForwardRef as ReactComponent };